module.exports = __webpack_public_path__ + "static/mr-press-02-1afd75f7b1fcb40116dc0875e75540d0.jpg";